export enum TradeCollateralization {
  /** Uncollateralized */
  Uncollateralized = 0,
  /** Partially collateralized */
  PartiallyCollateralized = 1,
  /** One-way collaterallization */
  OneWayCollaterallization = 2,
  /** Fully collateralized */
  FullyCollateralized = 3,
  NetExposure = 4,
}
